export const environment = {
    production: true,
    api: 'https://qa.api.classichub.co.nz',
    buildVersion: '2026.7.2.3',
    uri: 'https://qa.classichub.co.nz',
    envName: 'qa',
    isTest: true,
};

